module.exports = __webpack_public_path__ + "img/wrench.3dbabd0b.svg";